export enum DateTimeFormatEnum {
  StandardDateFormat = 'yyyy-MM-DD',
  StandardDateTimeFormat = 'yyyy-MM-DD HH:mm:ss',
  ShortDate = 'MMM D, yyyy',
  DayInMonth = 'MMMM DD',
  DateWithTime = 'MMM D, y | h:mm a',
  EUDateFormat = 'DD-MM-yyyy',
  FullDateWithYear = 'ddd, MMM D, yyyy',
  DateOnly = 'MMM D',
  NewGenerationDate = 'MMM D, yyyy @ h:mm a',
  DateTimeWithDash = 'MMM D, yyyy - hh:mm A',
  MonthYear = 'MMM, YYYY',
}

export enum TimeStyleEnum {
  Short = 'short',
}

export enum DateStyleEnum {
  Short = 'short',
  Medium = 'medium',
  MediumDate = 'mediumDate',
  LongDate = 'long',
}

export enum TimeFormat {
  StartTime = 'T00:00:00',
  EndTime = 'T23:59:59',
}
